module.exports = __webpack_public_path__ + "img/20180815_145537_005.a431e7d4.jpg";